(() => {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("aL67E", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", () => $7d530af6a65dce80$export$bdfd709ae4826697, (v) => $7d530af6a65dce80$export$bdfd709ae4826697 = v);
var $7d530af6a65dce80$export$bdfd709ae4826697;
var $7d530af6a65dce80$export$c9e73fbda7da57b6;
var $7d530af6a65dce80$export$5a759dc7a1cfb72a;
"use strict";
var $7d530af6a65dce80$var$bundleURL = {};
function $7d530af6a65dce80$var$getBundleURLCached(id) {
    var value = $7d530af6a65dce80$var$bundleURL[id];
    if (!value) {
        value = $7d530af6a65dce80$var$getBundleURL();
        $7d530af6a65dce80$var$bundleURL[id] = value;
    }
    return value;
}
function $7d530af6a65dce80$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ('' + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $7d530af6a65dce80$var$getBaseURL(matches[2]);
    }
    return '/';
}
function $7d530af6a65dce80$var$getBaseURL(url) {
    return ('' + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, '$1') + '/';
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $7d530af6a65dce80$var$getOrigin(url) {
    var matches = ('' + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error('Origin not found');
    return matches[0];
}
$7d530af6a65dce80$export$bdfd709ae4826697 = $7d530af6a65dce80$var$getBundleURLCached;
$7d530af6a65dce80$export$c9e73fbda7da57b6 = $7d530af6a65dce80$var$getBaseURL;
$7d530af6a65dce80$export$5a759dc7a1cfb72a = $7d530af6a65dce80$var$getOrigin;

});

var $96d1dbc191802ea9$exports = {};

$96d1dbc191802ea9$exports = (parcelRequire("aL67E")).getBundleURL('ixp5M') + "hero-phone.9070f40d.jpg";


var $9dfbe57d57ff7a99$exports = {};

$9dfbe57d57ff7a99$exports = (parcelRequire("aL67E")).getBundleURL('ixp5M') + "hero-mac.852ce857.jpg";


const $94509d50a7e2768d$var$fullImages = {
    phone: new URL($96d1dbc191802ea9$exports),
    mac: new URL($9dfbe57d57ff7a99$exports)
};
for (const [name, url] of Object.entries($94509d50a7e2768d$var$fullImages)){
    const image = document.querySelector(`.hero-image-${name}`);
    // Wait for the small placeholder so the full image doesn't compete for bandwidth.
    const upgrade = ()=>{
        const full = new Image();
        full.src = url;
        full.decode().then(()=>{
            image.src = full.src;
        }, ()=>{});
    };
    if (image.complete) upgrade();
    else image.addEventListener('load', upgrade, {
        once: true
    });
}

})();
//# sourceMappingURL=index.57874883.js.map
